<template>
    <q-modal v-model="modalOrder" no-backdrop-dismiss no-esc-dismiss>
        <div>
            <v-header :title="$T('order detail') + ' ' + (order.id || '')" icon="find in page">
                <template slot="right">
                    <v-button flat rounded dense color="primary"
                              icon="close"
                              :label="$T('close')"
                              @click="close"/>
                </template>
            </v-header>
            <card width="100%">


            </card>
        </div>
    </q-modal>
</template>


<script>
    import {
        QSpinnerPuff,
        QModal
    } from 'quasar-framework'

    export default {
        components: {
            QSpinnerPuff,
            QModal
        },

        props: {
            show: Boolean,
            order: {
                type: Object,
                default: {}
            }
        },

        data() {
            return {
                modalOrder: this.show,
                form: {}
            }
        },

        watch: {
            show(newVal) {
                this.modalOrder = newVal
            }
        },

        methods: {
            close() {
                this.modalOrder = false
                this.$emit('close')
            }
        }
    }

</script>



// WEBPACK FOOTER //
// resources/assets/js/pages/device/importDevices.vue